import { Suspense, lazy } from "react";
import { mobile } from "../responsive";
import { useLocation, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { publicRequest } from "../requestMethod";
import { addProduct } from "../redux/cartRedux";
import { useDispatch } from "react-redux";
import { enGB } from "date-fns/locale";
import { addDays, parse } from "date-fns";
import { categories } from "../data";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import axios from "axios";
const RecProducts = lazy(() => import("../Components/RecProducts"));
const Footer = lazy(() => import("../Components/Footer"));
const Navbar = lazy(() => import("../Components/Navbar"));
const ProfileImage = lazy(() => import("../Components/ProfileImage"));
const DatePicker = lazy(() => import("react-datepicker"));

const PeopleIcon = lazy(() => import("@mui/icons-material/People"));
const LocalShippingIcon = lazy(() =>
  import("@mui/icons-material/LocalShipping")
);
const ProductMap = lazy(() => import("../Components/ProductMap"));
const Reviews = lazy(() => import("../Components/Reviews"));
const SEO = lazy(() => import("../Components/SEO"));
const Loader = lazy(() => import("../Components/Loader"));
const AccordionSummary = lazy(() => import("@mui/material/AccordionSummary"));
const AccordionDetails = lazy(() => import("@mui/material/AccordionDetails"));
const Accordion = lazy(() => import("@mui/material/Accordion"));
const ExpandMoreIcon = lazy(() => import("@mui/icons-material/ExpandMore"));
const LaunchIcon = lazy(() => import("@mui/icons-material/Launch"));

const Container = styled.div``;

const FourContainer = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 1em 0.5em 0em 0.5em;
  margin: 10% 0;
  box-sizing: border-box;
  h3 {
    margin-top: 1em;
  }
  p {
    margin: 1em;
  }
`;

const Wrapper = styled.div`
  margin-top: 5px;
  padding: 50px;
  display: flex;
  ${mobile({ padding: "10px", flexDirection: "column" })}
`;

const ImgContainer = styled.div`
  flex: 1;
  flex-direction: row;
  ${mobile({ width: "95%", justifyContent: "center" })}
`;
const ImgThumbContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
`;

const Image = styled.img`
  width: 90%;
  height: 400px;

  object-fit: contain;
  ${mobile({ height: "40vh", width: "90%" })}
`;
const ImageThumb = styled.img`
  flex-direction: row !important;
  width: 25%;

  height: 5em;
  object-fit: scale-down;
  padding: 0.4em;
  border: 1px solid grey;
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
`;
const InfoContainer = styled.div`
  flex: 1;
  padding: 0px 50px;
  margin-top: 2em;
  ${mobile({ display: "none" })}
`;
const InfoContainerMobile = styled.div`
  flex: 1;
  padding: 0px 50px;
  margin-top: 2em;
  display: none;
  ${mobile({
    padding: "0.8em",
    display: "flex !important",
    flexDirection: "column",
  })}
`;

const Title = styled.h1`
  font-weight: 600;
  margin: 0.5em 0;

  ${mobile({ display: "none" })}
`;
const TitleMobile = styled.h1`
  font-weight: 600;
  margin: 0.5em 0;
  display: none;

  ${mobile({ display: "flex" })}
`;

const Desc = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1em 0;
  padding: 1em 0;
  white-space: pre-wrap;
  width: 75%;
  h5 {
    margin: 1em 0 0.5em 0;
  }
  h3 {
    margin: 1em 0 0.5em 0;
  }
  h2 {
    font-size: 1.3em;
  }
  p {
    margin-top: 1em;
  }
  ${mobile({ width: "95%" })}
`;

const GMap = styled.div`
  margin: 1em 0;
  padding: 1em 0;
  white-space: pre-wrap;
  width: 75%;
  h4 {
    margin-bottom: 0.5em;
  }
  p {
    color: white;
    font-weight: 100;
    font-size: 0.8em;
    text-align: center;
    width: 100% -10px;
    background-color: #6b64fa;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 0.3em;
  }
  ${mobile({ width: "100%" })}
`;

const Price = styled.span`
  font-weight: 100;
  font-size: 40px;
`;

const AddContainer = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mobile({
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
  })}
`;
const InfoText = styled.span`
  font-size: 12px;
`;
const DeliveryContainer = styled.div`
  flexdirection: column;
  alignitems: flex-start;
  border-left: 1px solid #c7c7c7;
  border-right: 1px solid #c7c7c7;
  border-bottom: 1px solid #c7c7c7;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;

  select {
    border: none;
  }
  ${InfoText} {
    margin-left: 0.5em;
  }
`;

const DatePickerWrapper = styled.div`
  height: auto;
  width: 50%;
  margin: 0.5em 0 0 0;
  border-top: 1px solid #c7c7c7;
  border-bottom: 1px solid #c7c7c7;
  border-top-left-radius: 10px;

  input {
    height: 2.5em;
    width: 90%;
    text-indent: 0.5em;
    font-weight: 600;
    border: none;
    cursor: pointer;
    @media (max-width: 768px) {
      width: 90%;
    }
  }

  & .react-datepicker__day--selected {
    background-color: rgb(107, 100, 250) !important;
  }

  ${InfoText} {
    margin-left: 0.5em;
  }
`;

const InfoPostage = styled.p`
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flexwrap: wrap;
  border-radius: 10px;
  padding: 0.3em;
`;

const RentalBox = styled.div`
  margin: 1.5em 0;
  width: 50%;
  h4 {
    margin-bottom: 0.5em;
  }
  ${InfoText} {
    font-size: 0.7em;
  }

  ${mobile({ width: "100%" })}
`;

const DeliveryOptions = styled.div`
  margin: 0.5em 0;
  display: flex;

  h4 {
    margin: 0.5em 0;
  }

  ${mobile({ flexDirection: "column" })}
`;

const FlexTwo = styled.div`
  display: flex;
  flex-direction: row;

  ${DatePickerWrapper} {
    border-top-left-radius: 10px;
    border-left: 1px solid #c7c7c7;

    &:last-of-type {
      border-top-right-radius: 10px;
      border-top-left-radius: 0px;
      border-right: 1px solid #c7c7c7;
    }
  }
`;

const ButtonGo = styled.button`
  background-color: rgb(99, 91, 255);
  font-size: 18px;
  color: #fff;
  font-weight: 500;
  min-height: 40px;
  margin: 1em 0 1em 0;
  border: solid 2px rgb(99, 91, 255);
  border-radius: 10px;
  width: 105%;
  cursor: pointer;

  &:hover {
    background-color: rgb(107, 100, 250);
    cursor: pointer;
  }
`;

const SelectInput = styled.select`
  width: 100%;
  line-height: 30px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  padding: 0.3em 0 0.3em 0.5em;
  background-color: #fff;

  option {
    background-color: #fff;
  }
`;

const Nav = styled.nav`
  margin: 0.5em 0 0.5em 0.5em;
`;

const CrumbsOl = styled.ol`
  list-style-type: none;
  padding-left: 0;
`;

const Crumb = styled.li`
  display: inline-block;
  text-overflow: elipsis;
  a::after {
    display: inline-block;
    color: #767676;
    content: ">";
    font-size: 80%;
    font-weight: bold;
    padding: 0 3px;
  }
`;

const DescContainer = styled.div`
  margin-top: 2em;
  background-color: #f7f7f7;
  border: 1px solid #f2f4ff;
  border-radius: 15px;
  padding: 1em;
  max-width: 80%;

  ${mobile({ maxWidth: "95%" })}
`;

const BookInfo = styled.div`
  p {
    margin-top: 0.3em;
  }
`;

const QuickQuestions = styled.div`
  margin: 1em 10% 1em 10%;
`;
const Typography = styled.div`
  margin: 1em;
  p {
    margin: 1em 0;
  }
`;

const Reduction = styled.div`
  color: #4339fa;
  font-size: 0.36em;
  border: 1px solid #4339fa;
  background: #fff;
  border-radius: 3px;
  padding: 0 4px 1px;
  margin: 0 0.3em 0.3em 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.2em;
  white-space: nowrap;
`;
const OriginalPrice = styled.div`
  color: #393939;
  text-decoration: line-through;
  font-size: 0.36em;

  padding: 0 4px 1px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.1em;
  white-space: nowrap;
`;

const BeforeYouRent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${mobile({ flexDirection: "column" })}
`;

const componentDidMount = () => {
  window.scrollTo(0, 0);
};

const Product = () => {
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const [toggle, setToggle] = useState(1);
  const [product, setProduct] = useState({});
  const quantity = 1;
  const [prodStartDate, setProdStartDate] = useState(null);
  const [prodEndDate, setProdEndDate] = useState(null);
  var excludeDates = [];
  const [minBookableDate, setMinBookableDate] = useState(null);
  const [deliveryMethod, setDeliveryMethod] = useState();
  const [deliveryOptions, setDeliveryOptions] = useState();
  const [updateImg, setUpdateImg] = useState("required");
  const [error, setError] = useState("");
  const [bag, setBag] = useState("");
  const [showBookInfo, setShowBookInfo] = useState(false);
  var duration = 0;
  const [gMap, setGMap] = useState("");
  const uid = new URLSearchParams(location.search).get("uid");
  const [soft, setSoft] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const getProduct = async () => {
      try {
        let res = await publicRequest.get("products/find/" + id);

        if (res.status === 404) {
          setSoft(1);
        }
        setGMap(
          res.data.deliveryMethods.includes("collection") &&
            res.data.location?.coordinates != "undefined" &&
            res.data.location?.coordinates != "null" &&
            res.data.location?.coordinates?.length > 1
        );

        setDeliveryOptions(res.data.deliveryMethods.sort());
        setDeliveryMethod(res.data.deliveryMethods.sort()[0]);

        setProduct(res.data);
      } catch (err) {
        setSoft(1);
      }
    };
    getProduct();
    componentDidMount();
  }, [id]);

  useEffect(() => {
    try {
      product?.category[0] === "books" && setShowBookInfo(true);

      if (product.desc.length === 13 && product?.category[0] === "books") {
        setUpdateImg(product.desc);
        const isbn = product.desc;

        const getBookInfo = async () => {
          try {
            const bookData = await axios.get(
              `https://www.googleapis.com/books/v1/volumes?q=isbn:${product.desc}`
            );
            if (
              bookData.data.totalItems === 0 ||
              bookData.data.totalItems === undefined
            ) {
              setSoft(1);
            }

            const index = bookData.data.totalItems === 2 ? 1 : 0;

            const desc = bookData?.data?.items[index]?.volumeInfo?.description;
            const author =
              bookData?.data?.items[index]?.volumeInfo?.authors?.toString();

            const publisher =
              bookData?.data?.items[index]?.volumeInfo?.publisher;

            setProduct((prevData) => ({
              ...prevData,
              desc: desc,
              author: author,
              publisher: publisher,
              isbn: isbn,
            }));
          } catch (err) {}
        };

        getBookInfo();
      }
    } catch (err) {}
  }, [product]);

  useEffect(() => {
    const updateImage = async () => {
      if (updateImg.length === 13) {
        const coverImageStart = await axios.get(
          `https://openlibrary.org/search.json?isbn=${updateImg}&fields=cover_i`
        );

        try {
          const imgData = coverImageStart.data.docs[0].cover_i;

          if (imgData !== undefined) {
            const finalImage = `https://covers.openlibrary.org/b/id/${imgData}-L.jpg`;

            const timeoutId = setTimeout(() => {
              setUpdateImg(finalImage);
            }, 500);

            return () => clearTimeout(timeoutId);
          } else {
            setUpdateImg(product.img ? product.img : "/nimage.svg");
          }
        } catch (err) {}
      }
    };
    updateImage();
  }, [updateImg]);

  const handleChange = (e) => {
    setDeliveryMethod(e.target.value.toLowerCase());
  };

  const handleClick = () => {
    try {
      const startDate = prodStartDate.toLocaleDateString("en-GB");
      const endDate = prodEndDate.toLocaleDateString("en-GB");
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      duration = Math.abs(prodEndDate - prodStartDate) / _MS_PER_DAY;
      dispatch(
        addProduct({
          ...product,
          quantity,
          duration,
          startDate,
          endDate,
          deliveryMethod,
        })
      );
      setBag(`✓ Added`);
    } catch (err) {
      setError(`Please select arrival and return by dates.`);
    }
  };

  useEffect(() => {
    if (prodStartDate && excludeDates) {
      const filterByExpiration = (arr) =>
        arr.filter((date) => new Date(date) > prodStartDate);
      const arr = filterByExpiration(excludeDates);

      const mins = addDays(new Date(Math.min(...arr)), -1);

      setMinBookableDate(mins);
    }
  }, [prodStartDate]);

  const handleSelect = (e) => {
    if (prodStartDate && prodEndDate) {
      setProdStartDate(null);
    }
  };

  useEffect(() => {
    if (soft === 1) {
      window.location.href = "/404.html";
    }
  }, [soft]);
  try {
    excludeDates = product.bookedDates?.map((item) => {
      try {
        const addDate = parse(item, "dd/MM/yyyy, HH:mm:ss", new Date());
        return addDate;
      } catch (err) {
        return item;
      }
    });
  } catch (err) {}
  if (toggle === 1) {
    let imageLoad = null;
    if (updateImg === "required" || updateImg.length === 13) {
      imageLoad = product.img;
      var mainImg = imageLoad;
    } else {
      imageLoad = updateImg;
      var mainImg = imageLoad;
    }
  } else if (toggle === 2) {
    var mainImg = product.img2;
  } else if (toggle === 3) {
    var mainImg = product.img3;
  } else if (toggle === 4) {
    var mainImg = product.img4;
  } else if (toggle === 5) {
    var mainImg = product.img5;
  } else if (toggle === 6) {
    var mainImg = product.img6;
  } else var mainImg = null;

  const catTitle = categories.filter((element) => {
    if (product?.category == element.cat) {
      return element;
    }
  });

  function determineArticle(word) {
    const vowels = ["a", "e", "i", "o", "u"];
    const firstLetter = word?.toLowerCase()?.charAt(0);

    if (vowels.includes(firstLetter)) {
      return "an";
    } else {
      return "a";
    }
  }
  const prefix = determineArticle(product.title);

  let seoTitle = `${
    catTitle[0]?.title === "Books"
      ? "Borrow " + product.title
      : "Rent " + prefix + " " + product.title
  } | Hire things on Rentoodle.`;
  let seoDesc = `${
    catTitle[0]?.title === "Books"
      ? "Borrow " + product.title
      : "Rent " + prefix + " " + product.title
  } ${product?.brand ? `(${product?.brand})` : ``}. Find similar ${
    catTitle[0]?.title ? catTitle[0]?.title : ""
  } available to hire via delivery or collection on Rentoodle.com`;

  return (
    <Suspense fallback={<Loader />}>
      {soft === 1 ? (
        <div>
          <SEO
            title="404 Not Found | Rentoodle.com"
            description="404 Not Found. Rentoodle.com - the advertising platform for renting stuff"
          />
          <Navbar />
          <FourContainer>
            <h1>
              This item may have been removed. We're not sure if it'll be back
              on Rentoodle.
            </h1>

            <p>
              Please try searching for another item in the search box just above
              here.
            </p>
            <p>
              Alternatively, please visit the{" "}
              <Link to="/">Rentoodle homepage</Link>
            </p>
          </FourContainer>
          <Footer />
        </div>
      ) : (
        <>
          <SEO title={seoTitle} description={seoDesc} product={product} />
          <Container>
            <Navbar />

            {location.state && (
              <p
                style={{
                  height: "30px",
                  backgroundColor: "rgb(67, 57, 250)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "0.5em",
                }}
              >
                {location.state}
              </p>
            )}
            <Nav>
              <CrumbsOl>
                <Crumb>
                  <Link
                    to="/"
                    style={{ textDecoration: "none", color: "#747474" }}
                  >
                    Home
                  </Link>
                </Crumb>
                <Crumb>
                  <Link
                    to={
                      "/products/" +
                      (product?.category &&
                        (product?.category[0] === "books"
                          ? "book-genres"
                          : product?.category !== "undefined"
                          ? product?.category
                          : ""))
                    }
                    style={{ textDecoration: "none", color: "#747474" }}
                  >
                    {catTitle[0]?.title}
                  </Link>
                </Crumb>
                {catTitle[0]?.title === "Books" && product?.subCategory && (
                  <Crumb>
                    <Link
                      to={
                        `/products/${product?.category}/` +
                        (product?.subCategory !== "undefined"
                          ? encodeURIComponent(product?.subCategory)
                          : "")
                      }
                      style={{
                        textDecoration: "none",
                        color: "#747474",
                      }}
                    >
                      {product?.subCategory ? product?.subCategory : ""}
                    </Link>
                  </Crumb>
                )}

                <Crumb>
                  {product?.title?.length > 45
                    ? product?.title?.substring(0, 45) + "..."
                    : product?.title}
                </Crumb>
              </CrumbsOl>
            </Nav>
            <Wrapper>
              <ImgContainer>
                <Image
                  fetchpriority="high"
                  src={mainImg}
                  alt={`rent ${product.title}`}
                />
                <ImgThumbContainer>
                  {product.img && (
                    <ImageThumb
                      src={product.img}
                      alt={`image of ${product.title}`}
                      onClick={() => setToggle(1)}
                      loading="lazy"
                    />
                  )}
                  {product.img2 && (
                    <ImageThumb
                      src={product.img2}
                      alt={`second image of ${product.title}`}
                      onClick={() => setToggle(2)}
                      loading="lazy"
                    />
                  )}
                  {product.img3 && (
                    <ImageThumb
                      src={product.img3}
                      alt={`third image of ${product.title}`}
                      onClick={() => setToggle(3)}
                      loading="lazy"
                    />
                  )}
                  {product.img4 && (
                    <ImageThumb
                      src={product.img4}
                      alt={`fourth image of ${product.title}`}
                      onClick={() => setToggle(4)}
                      loading="lazy"
                    />
                  )}
                  {product.img5 && (
                    <ImageThumb
                      src={product.img5}
                      alt={`fifth image of ${product.title}`}
                      onClick={() => setToggle(5)}
                      loading="lazy"
                    />
                  )}
                  {product.img6 && (
                    <ImageThumb
                      src={product.img6}
                      alt={`sixth image of ${product.title}`}
                      onClick={() => setToggle(6)}
                      loading="lazy"
                    />
                  )}
                </ImgThumbContainer>

                <TitleMobile>
                  Rent{" "}
                  {catTitle[0]?.cat?.includes("book") ||
                  catTitle[0]?.cat?.includes("game")
                    ? ""
                    : prefix}{" "}
                  {product.title}
                </TitleMobile>
                <InfoContainerMobile>
                  <Price>
                    £{product.price?.toFixed(2)} <InfoText>per day</InfoText>
                    {product?.rrp && (
                      <div style={{ display: "flex" }}>
                        <Reduction>
                          {product?.rrp
                            ? "Save " +
                              (
                                100 *
                                (1 - product?.price / product?.rrp)
                              ).toFixed(0) +
                              "%"
                            : ""}
                        </Reduction>
                        <OriginalPrice>
                          £{product?.rrp?.toFixed(2)}
                        </OriginalPrice>
                      </div>
                    )}
                    <p style={{ color: "#393939", fontSize: "0.36em" }}>
                      {product.minRentalPeriod} days minimum rental
                    </p>
                  </Price>
                  <DeliveryOptions>
                    {product.postageCost ? (
                      <InfoPostage>
                        <LocalShippingIcon style={{ margin: "0 0.3em" }} />£
                        {product.postageCost === 0
                          ? "FREE"
                          : product.postageCost?.toFixed(2)}{" "}
                        tracked delivery
                      </InfoPostage>
                    ) : null}
                    {product.deliveryMethods?.includes("collection") ? (
                      <InfoPostage>
                        <PeopleIcon style={{ margin: "0 0.3em" }} />
                        Free Click & Collect
                      </InfoPostage>
                    ) : null}
                  </DeliveryOptions>

                  <RentalBox>
                    {error ? (
                      <h4 style={{ color: "red" }}>
                        Please select rental dates:
                      </h4>
                    ) : uid ? (
                      <h4>Update your rental dates:</h4>
                    ) : (
                      ""
                    )}

                    <FlexTwo>
                      <DatePickerWrapper>
                        <InfoText>Arrives by</InfoText>
                        <DatePicker
                          onFocus={(e) => e.target.blur()}
                          selectsRange={false}
                          selected={prodStartDate}
                          excludeDates={excludeDates}
                          onChange={(update) => {
                            setProdEndDate(null);
                            setProdStartDate(update);
                          }}
                          onClick={handleSelect}
                          minDate={addDays(
                            new Date(),
                            product.minRentalPeriod
                              ? product.minRentalPeriod
                              : 2
                          )}
                          showPopperArrow={false}
                          disabledKeyboardNavigation
                          locale="enGB"
                          dateFormat={"dd/MM/yyyy"}
                          placeholderText="dd/mm/yyyy"
                        />
                      </DatePickerWrapper>

                      <DatePickerWrapper>
                        <InfoText>Return by</InfoText>
                        <DatePicker
                          onFocus={(e) => e.target.blur()}
                          selectsRange={false}
                          selected={prodEndDate}
                          excludeDates={excludeDates}
                          onChange={(update) => {
                            setProdEndDate(update);
                          }}
                          showPopperArrow={false}
                          maxDate={
                            !isNaN(minBookableDate) ? minBookableDate : null
                          }
                          minDate={addDays(
                            new Date(prodStartDate),
                            product.minRentalPeriod
                              ? product.minRentalPeriod
                              : 2
                          )}
                          disabledKeyboardNavigation
                          locale={enGB}
                          dateFormat={"dd/MM/yyyy"}
                          placeholderText="dd/mm/yyyy"
                        />
                      </DatePickerWrapper>
                    </FlexTwo>
                    <DeliveryContainer>
                      <InfoText>Pick-up/Delivery</InfoText>

                      <SelectInput name="delivery" onChange={handleChange}>
                        {deliveryOptions?.map((e) => {
                          return (
                            <option value={e} key={e}>
                              {e.charAt(0).toUpperCase() + e.slice(1)}
                            </option>
                          );
                        })}
                      </SelectInput>
                    </DeliveryContainer>
                  </RentalBox>

                  <AddContainer style={{ flexDirection: "column" }}>
                    {bag && <h4 style={{ color: "#4339fa" }}>{bag}</h4>}
                    <ButtonGo onClick={handleClick}>
                      {uid ? `UPDATE BAG` : `ADD TO BAG`}
                    </ButtonGo>
                  </AddContainer>
                  <div style={{ marginTop: "1em" }}>
                    <div
                      style={{
                        fontSize: "1.3em",
                        fontWeight: "bold",
                        marginBottom: "0.5em",
                      }}
                    >
                      Owner details
                    </div>
                    {product.lenderId && (
                      <ProfileImage id={product?.lenderId} />
                    )}
                  </div>
                  {gMap && (
                    <GMap>
                      {" "}
                      <div
                        style={{
                          fontSize: "1.3em",
                          fontWeight: "bold",
                          marginBottom: "0.5em",
                        }}
                      >
                        Location
                      </div>
                      <p>Collecting? Exact location provided after checkout.</p>
                      <ProductMap coords={product?.location?.coordinates} />
                    </GMap>
                  )}
                </InfoContainerMobile>
                <DescContainer>
                  <h2>Description</h2>

                  <p>{product.desc}</p>
                  <p
                    style={{
                      marginTop: "1em",
                    }}
                  >
                    It costs £{product?.price?.toFixed(2)} per day or £
                    {(product?.price * 7)?.toFixed(2)} a week to hire{" "}
                    {catTitle[0]?.cat?.includes("book") ||
                    catTitle[0]?.cat?.includes("game")
                      ? ""
                      : prefix}{" "}
                    {product.title}.
                  </p>
                  {product?.brand !== undefined &&
                    product?.brand !== "" &&
                    product?.brand !== "undefined" && (
                      <p>Brand: {product.brand}</p>
                    )}

                  {showBookInfo && (
                    <BookInfo>
                      <p
                        style={{
                          fontSize: "1.3em",
                          fontWeight: "bold",
                          margin: "1em 0",
                        }}
                      >
                        Book Details
                      </p>
                      <p>
                        <b>Author:</b>{" "}
                        {product?.author
                          ? product?.author?.replace(",", ", ")
                          : "Unknown"}
                      </p>
                      <p>
                        <b>ISBN:</b> {product.isbn ? product.isbn : "Unknown"}
                      </p>
                      <p>
                        <b>Publisher:</b>{" "}
                        {product.publisher ? product.publisher : "Unknown"}
                      </p>
                    </BookInfo>
                  )}

                  <p
                    style={{
                      marginTop: "1em",
                    }}
                  >
                    Have something similar?
                    <Link
                      to="/upload"
                      style={{
                        textDecoration: "none",
                        color: "#4339fa",
                        fontWeight: "bold",
                      }}
                    >
                      {" "}
                      List it for rent
                    </Link>
                  </p>
                </DescContainer>
                <DescContainer>
                  <p style={{ fontSize: "1.3em", fontWeight: "bold" }}>
                    Before you rent
                  </p>
                  <BeforeYouRent>
                    <img
                      src="https://www.rentoodle.com/img/strp-logo.svg"
                      height="70px"
                      alt="identity checks are conducted by Stripe"
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "1em",
                      }}
                    >
                      <p>
                        To keep Rentoodle a safe place for people to share their
                        belongings, ID verification is required before you can
                        {catTitle[0]?.title === "Books"
                          ? " borrow this book"
                          : " hire this " + product?.title}
                        .
                      </p>
                      <p>
                        If you're not already verified, you will be redirected
                        to the Stripe website to securely validate your ID after
                        checkout.
                      </p>
                      <p>
                        Rentoodle does not store your identity documents.{" "}
                        <Link
                          to="/faqs"
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "#4339fa",
                            fontWeight: "bold",
                          }}
                        >
                          Learn More about Rentoodle
                          <LaunchIcon fontSize="small" />
                        </Link>
                      </p>
                    </div>
                  </BeforeYouRent>
                </DescContainer>
              </ImgContainer>
              <InfoContainer>
                <Title>
                  Rent{" "}
                  {catTitle[0]?.cat?.includes("book") ||
                  catTitle[0]?.cat?.includes("game")
                    ? ""
                    : prefix}{" "}
                  {product.title}
                </Title>
                <Price>
                  £{product.price?.toFixed(2)} <InfoText>per day</InfoText>
                  {product?.rrp && (
                    <div style={{ display: "flex" }}>
                      <Reduction>
                        {product?.rrp
                          ? "Save " +
                            (100 * (1 - product?.price / product?.rrp)).toFixed(
                              0
                            ) +
                            "%"
                          : ""}
                      </Reduction>
                      <OriginalPrice>£{product?.rrp?.toFixed(2)}</OriginalPrice>
                    </div>
                  )}
                  <p style={{ color: "#393939", fontSize: "0.36em" }}>
                    {product.minRentalPeriod} days minimum rental
                  </p>
                </Price>
                <DeliveryOptions>
                  {product.postageCost ? (
                    <InfoPostage>
                      <LocalShippingIcon style={{ margin: "0 0.3em" }} />£
                      {product.postageCost === 0
                        ? "FREE"
                        : product.postageCost?.toFixed(2)}{" "}
                      tracked delivery
                    </InfoPostage>
                  ) : null}
                  {product.deliveryMethods?.includes("collection") ? (
                    <InfoPostage>
                      <PeopleIcon style={{ margin: "0 0.3em" }} />
                      Free Click & Collect
                    </InfoPostage>
                  ) : null}
                </DeliveryOptions>

                <RentalBox>
                  {error ? (
                    <h4 style={{ color: "red" }}>
                      Please select rental dates:
                    </h4>
                  ) : uid ? (
                    <h4>Update your rental dates:</h4>
                  ) : (
                    ""
                  )}

                  <FlexTwo>
                    <DatePickerWrapper>
                      <InfoText>Arrives by</InfoText>
                      <DatePicker
                        onFocus={(e) => e.target.blur()}
                        selectsRange={false}
                        selected={prodStartDate}
                        excludeDates={excludeDates}
                        onChange={(update) => {
                          setProdEndDate(null);
                          setProdStartDate(update);
                        }}
                        onClick={handleSelect}
                        minDate={addDays(
                          new Date(),
                          product.minRentalPeriod ? product.minRentalPeriod : 2
                        )}
                        showPopperArrow={false}
                        disabledKeyboardNavigation
                        locale="enGB"
                        dateFormat={"dd/MM/yyyy"}
                        placeholderText="dd/mm/yyyy"
                      />
                    </DatePickerWrapper>

                    <DatePickerWrapper>
                      <InfoText>Return by</InfoText>
                      <DatePicker
                        onFocus={(e) => e.target.blur()}
                        selectsRange={false}
                        selected={prodEndDate}
                        excludeDates={excludeDates}
                        onChange={(update) => {
                          setProdEndDate(update);
                        }}
                        showPopperArrow={false}
                        maxDate={
                          !isNaN(minBookableDate) ? minBookableDate : null
                        }
                        minDate={addDays(
                          new Date(prodStartDate),
                          product.minRentalPeriod ? product.minRentalPeriod : 2
                        )}
                        disabledKeyboardNavigation
                        locale={enGB}
                        dateFormat={"dd/MM/yyyy"}
                        placeholderText="dd/mm/yyyy"
                      />
                    </DatePickerWrapper>
                  </FlexTwo>
                  <DeliveryContainer>
                    <InfoText>Pick-up/Delivery</InfoText>

                    <SelectInput name="delivery" onChange={handleChange}>
                      {deliveryOptions?.map((e) => {
                        return (
                          <option value={e} key={e}>
                            {e.charAt(0).toUpperCase() + e.slice(1)}
                          </option>
                        );
                      })}
                    </SelectInput>
                  </DeliveryContainer>
                </RentalBox>

                <AddContainer style={{ flexDirection: "column" }}>
                  {bag && <h4 style={{ color: "#4339fa" }}>{bag}</h4>}
                  <ButtonGo onClick={handleClick}>
                    {uid ? `UPDATE BAG` : `ADD TO BAG`}
                  </ButtonGo>
                </AddContainer>
                <div style={{ marginTop: "1em" }}>
                  <div
                    style={{
                      fontSize: "1.3em",
                      fontWeight: "bold",
                      marginBottom: "0.5em",
                    }}
                  >
                    Owner details
                  </div>
                  {product.lenderId && <ProfileImage id={product?.lenderId} />}
                </div>

                {gMap && (
                  <GMap>
                    {" "}
                    <div
                      style={{
                        fontSize: "1.3em",
                        fontWeight: "bold",
                        marginBottom: "0.5em",
                      }}
                    >
                      Location
                    </div>
                    <p>Collecting? Exact location provided after checkout.</p>
                    <ProductMap coords={product?.location?.coordinates} />
                  </GMap>
                )}
              </InfoContainer>
            </Wrapper>
            <div
              style={{
                borderTop: "1px solid #C7C7C7",
                fontWeight: "bold",
                padding: "1em",
                margin: "1em",
              }}
            >
              <h2 style={{ fontSize: "1.3em" }}>Lender Reviews</h2>
            </div>
            <Reviews lenderId={product.lenderId} />
            <div
              style={{
                borderTop: "1px solid #C7C7C7",
                fontWeight: "bold",
                padding: "1em",
                margin: "1em",
              }}
            >
              <h2>People also viewed</h2>
            </div>
            {product?.category && <RecProducts cat={product?.category[0]} />}
            {/* <div
              style={{
                borderTop: "1px solid #C7C7C7",
                fontWeight: "bold",
                padding: "1em",
                margin: "1em",
              }}
            >
              <h2>Common questions</h2>
            </div>
            <QuickQuestions>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel0-content"
                  id="panel0-header"
                >
                  <Typography>
                    <img
                      src="https://www.rentoodle.com/img/hiscox.svg"
                      height="70px"
                      alt="Hiscox underwrites the Rentoodle Lender Guarantee"
                    />
                    <br />
                    <p>What is Hiscox Insurance?</p>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p>
                      Every lender's item rented out on Rentoodle in accordance
                      with the Rentoodle Lenders Guarantee, is protected by
                      £30,000 of cover by Hiscox insurance. Rentoodle have
                      chosen Hiscox to provide up to £30,000 cover, in case a
                      lender's item is lost, damaged or stolen during a rental.
                    </p>
                    <p style={{ marginTop: "1em" }}>
                      Please note that any lost, stolen or damaged items will
                      still need to be paid for in full{" "}
                      {product.rrp && "(Approximately £" + product.rrp + ")"} by
                      the Hirer and the lender guarantee does not protect
                      hirers.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                >
                  <Typography>
                    <p>How does renting work?</p>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p>
                      Rentoodle is a peer-to-peer rental marketplace — we
                      connect people who need stuff with people who have stuff.
                    </p>
                    <p>
                      Find what you’re looking for, choose delivery or
                      collection and book the item for the dates you need. If
                      you're not already, you'll need to get ID verified by
                      Stripe, our identity check provider.
                    </p>
                    <p>
                      If collecting, arrange a time with the Lender to collect
                      your item and enjoy your rental. Return the item to the
                      renter in person by the rental end date.{" "}
                    </p>
                    <p>
                      If delivery is selected, your item will be posted to you
                      via tracked delivery. Make sure you return the item by
                      tracked delivery, to arrive back with the lender by the
                      rental end date you select.
                    </p>
                    <p style={{ marginTop: "1em" }}>
                      Please note that any lost, stolen or damaged items will
                      need to be paid for in full{" "}
                      {product.rrp && "(Approximately £" + product.rrp + ")"} by
                      the Hirer to the Lender.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography>
                    <p>
                      How much does it cost to rent{" "}
                      {prefix + " " + product.title}?
                    </p>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p>
                      It costs £{product?.price?.toFixed(2)} per day or £
                      {(product?.price * 7)?.toFixed(2)} a week to hire {prefix}{" "}
                      {product.title}.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography>
                    <p>Is there a cancellation policy?</p>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p>
                      Free cancellation up to 48-hours before the rental start
                      date.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4-content"
                  id="panel4-header"
                >
                  <Typography>
                    <p>
                      Can I rent{" "}
                      {catTitle[0]?.title === "Books"
                        ? product.title
                        : prefix + " " + product.title}
                      ?
                    </p>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p>
                      It's easy to rent{" "}
                      {catTitle[0]?.title === "Books"
                        ? product.title
                        : prefix + " " + product.title}
                      . Simply book your rental dates, checkout and provide ID
                      verification via our secure automated system.
                    </p>

                    <p>
                      Save money by renting quality equipment and items you only
                      need short term. Many items can be posted to you by
                      tracked delivery. When returning by post, you'll also need
                      to pay for tracked delivery and carefully package your
                      items.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </QuickQuestions> */}

            <Footer />
          </Container>
        </>
      )}
    </Suspense>
  );
};

export default Product;
